import { EventConfig, OtherEventProtocol } from '@lighthouse/core'
import { eventTypeName, PopoverDropdownWithClose } from '@lighthouse/shared'
import React, { useCallback } from 'react'

import { CommonEventConfig } from './CommonEventConfig'

interface OtherEventConfigProps {
    value: OtherEventProtocol
    onChange: (value: OtherEventProtocol) => void
}

export const OtherEventConfig: React.FC<OtherEventConfigProps> = ({ value, onChange }) => {
    const { type, config } = value

    const handleConfigChange = useCallback(
        (val: EventConfig) => {
            onChange({
                ...value,
                config: val
            })
        },
        [onChange, value]
    )

    return (
        <PopoverDropdownWithClose title={eventTypeName[type]}>
            <CommonEventConfig value={config} onChange={handleConfigChange} />
        </PopoverDropdownWithClose>
    )
}
